import * as Actions from "auth/store/actions";

const initialState = {
  successUpdateUser: false,
  isUpdateUserLoading: false,
  errorUpdateUser: null,
};

const updateUser = (state = initialState, action) => {
  switch (action.type) {
    case Actions.UPDATE_USER_DATA_START: {
      return {
        ...initialState,
        isUpdateUserLoading: true,
      };
    }
    case Actions.UPDATE_USER_DATA_SUCCESS: {
      return {
        ...initialState,
        successUpdateUser: true,
        isUpdateUserLoading: false,
      };
    }
    case Actions.UPDATE_USER_DATA_FAILURE: {
      return {
        successUpdateUser: false,
        isUpdateUserLoading: false,
        errorUpdateUser: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default updateUser;
